import React from "react";
import { Route, Switch } from "react-router";
import { CreateAndEditSurveyComponentPaths } from "./SurveyComponentPaths";
import CreateAndEditSurveysMain from './CreateAndEditSurveys';
import SurveyTemplateManager from "./SurveyTemplateManager";
import SurveyCampaigns from "./SurveyCampaigns";
import CertificationConsolidationSurveyEditor from "./CertificationConsolidationSurveyEditor/CertificationConsolidationSurveyEditor";
import CertificationConsolidationResponseEditor from "./CertificationConsolidationResponseEditor/CertificationConsolidationResponseEditor";
import SurveyResponse from "./SurveyResponse";
import SupplierGapDocumentSubmissionPage from "./SupplierGapDocumentSubmission/SupplierGapDocumentSubmissionPage";
import { SupplierGapDocumentSubmissionPath } from "./SupplierGapDocumentSubmission/api";

// ===============================================================================
//
// Component that does all the routing for all the Survey components.
//
export class SurveyMain extends React.PureComponent {
    public render() {
        return (
            <Switch>
                <Route exact={true} path={SupplierGapDocumentSubmissionPath} component={SupplierGapDocumentSubmissionPage} />
                <Route exact={true} path={CreateAndEditSurveyComponentPaths.EditSurveyCertificationsRequestPath} component={CertificationConsolidationSurveyEditor} />
                <Route exact={true} path={CreateAndEditSurveyComponentPaths.EditSurveyResponse} component={SurveyResponse} />
                <Route exact={true} path={CreateAndEditSurveyComponentPaths.SurveyCampaignsPath} component={SurveyCampaigns} />
                <Route exact={true} path={CreateAndEditSurveyComponentPaths.CertificationConsolidationResponseEditorPath} component={CertificationConsolidationResponseEditor} />
                <Route exact={true} path={CreateAndEditSurveyComponentPaths.NewSurveyPath} component={CreateAndEditSurveysMain} />
                <Route exact={true} path={CreateAndEditSurveyComponentPaths.ManageSurveyTemplatePath} component={SurveyTemplateManager} />                
                <Route exact={true} path={CreateAndEditSurveyComponentPaths.EditSurveyTemplatePath} component={CreateAndEditSurveysMain} />
                <Route exact={true} path={CreateAndEditSurveyComponentPaths.ExistingSurveyPath} component={CreateAndEditSurveysMain} />
            </Switch>
        );
    }
}
